var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "import-file-modall",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("stores::products-info::import_goods"))),
      ]),
      _vm.show
        ? _c(
            "div",
            { staticClass: "content-box" },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "btn-item",
                  attrs: {
                    "auto-upload": false,
                    action: "",
                    drag: "",
                    "http-request": _vm.customUpload,
                    "on-change": _vm.onchangeUpload,
                    "show-file-list": false,
                  },
                },
                [
                  !_vm.select
                    ? _c("div", { staticClass: "upload-box" }, [
                        _c("i", {
                          staticClass: "iconfont iconUpload upload-btn mb-16",
                        }),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("stores::products-info::import_tips")
                              ) +
                              " "
                          ),
                          _c("a", { attrs: { type: "text" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("stores::products-info::import_btn")
                              )
                            ),
                          ]),
                        ]),
                      ])
                    : _c("div", { staticClass: "upload-box" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("stores::products-info::choose_file"))
                          ),
                        ]),
                        _c("span", { staticClass: "mt-10" }, [
                          _vm._v(_vm._s(_vm.select.name)),
                        ]),
                      ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "mt-10" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("stores::products-info::import_example"))),
        ]),
        _c(
          "a",
          {
            staticClass: "ml-5",
            attrs: {
              href:
                _vm.$store.state.language === "en"
                  ? "//ocean-img.algobuy.net/default/7d5bd82b847e419cb66f00108c10ca94.xlsx"
                  : "//ocean-img.algobuy.net/common/aa92ab6fd013475587b9e35b14aca544.xlsx",
              download: "template.xlsx",
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("stores::products-info::import_example_btn")) +
                " "
            ),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onSub },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }